/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Growth_Bullet_0Inputs */

const en_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Host facility for The First Tee of Central Iowa since 1996`)
};

const es_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalación anfitriona de The First Tee of Central Iowa desde 1996`)
};

const de_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seit 1996 Austragungsort für The First Tee of Central Iowa`)
};

const zh_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自 1996 年起担任 The First Tee of Central Iowa 的主办场地`)
};

const ar_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منشأة مضيفة لـThe First Tee of Central Iowa منذ 1996`)
};

const fr_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installation hôte de The First Tee of Central Iowa depuis 1996`)
};

const vi_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa điểm chủ nhà của The First Tee of Central Iowa từ năm 1996`)
};

const sw_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kituo mwenyeji cha The First Tee of Central Iowa tangu 1996`)
};

const th_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เป็นเจ้าภาพจัดงาน The First Tee of Central Iowa ตั้งแต่ปี 1996`)
};

const bs_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaćin objekat za The First Tee of Central Iowa od 1996.`)
};

const ja_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1996年より The First Tee of Central Iowa のホスト施設`)
};

const ko_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1996년부터 The First Tee of Central Iowa의 호스트 시설`)
};

const pt_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sede do The First Tee of Central Iowa desde 1996`)
};

const it_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Struttura ospitante per The First Tee of Central Iowa dal 1996`)
};

const sv_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Värdanläggning för The First Tee of Central Iowa sedan 1996`)
};

const nl_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gastlocatie van The First Tee of Central Iowa sinds 1996`)
};

const da_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Værtsfacilitet for The First Tee of Central Iowa siden 1996`)
};

const nb_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertsanlegg for The First Tee of Central Iowa siden 1996`)
};

const fi_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The First Tee of Central Iowa -ohjelman isäntäkenttä vuodesta 1996`)
};

const pl_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiekt goszczący The First Tee of Central Iowa od 1996 roku`)
};

const ru_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принимающая площадка The First Tee of Central Iowa с 1996 года`)
};

const tr_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1996'dan beri The First Tee of Central Iowa'nın ev sahibi tesisi`)
};

const hi_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1996 से The First Tee of Central Iowa की मेज़बान सुविधा`)
};

const id_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fasilitas tuan rumah The First Tee of Central Iowa sejak 1996`)
};

const ms_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuan rumah The First Tee of Central Iowa sejak 1996`)
};

const cs_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hostitelské zařízení programu The First Tee of Central Iowa od roku 1996`)
};

const el_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εγκατάσταση υποδοχής του The First Tee of Central Iowa από το 1996`)
};

const he_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתקן מארח של The First Tee of Central Iowa מאז 1996`)
};

const af_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gasheerfasiliteit vir The First Tee of Central Iowa sedert 1996`)
};

const hu_about_content_growth_bullet_0 = /** @type {(inputs: About_Content_Growth_Bullet_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1996 óta a The First Tee of Central Iowa fogadó létesítménye`)
};

/**
* | output |
* | --- |
* | "Host facility for The First Tee of Central Iowa since 1996" |
*
* @param {About_Content_Growth_Bullet_0Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_growth_bullet_0 = /** @type {((inputs?: About_Content_Growth_Bullet_0Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Growth_Bullet_0Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_growth_bullet_0(inputs)
	if (locale === "de") return de_about_content_growth_bullet_0(inputs)
	if (locale === "zh") return zh_about_content_growth_bullet_0(inputs)
	if (locale === "ar") return ar_about_content_growth_bullet_0(inputs)
	if (locale === "fr") return fr_about_content_growth_bullet_0(inputs)
	if (locale === "vi") return vi_about_content_growth_bullet_0(inputs)
	if (locale === "sw") return sw_about_content_growth_bullet_0(inputs)
	if (locale === "th") return th_about_content_growth_bullet_0(inputs)
	if (locale === "bs") return bs_about_content_growth_bullet_0(inputs)
	if (locale === "ja") return ja_about_content_growth_bullet_0(inputs)
	if (locale === "ko") return ko_about_content_growth_bullet_0(inputs)
	if (locale === "pt") return pt_about_content_growth_bullet_0(inputs)
	if (locale === "it") return it_about_content_growth_bullet_0(inputs)
	if (locale === "sv") return sv_about_content_growth_bullet_0(inputs)
	if (locale === "nl") return nl_about_content_growth_bullet_0(inputs)
	if (locale === "da") return da_about_content_growth_bullet_0(inputs)
	if (locale === "nb") return nb_about_content_growth_bullet_0(inputs)
	if (locale === "fi") return fi_about_content_growth_bullet_0(inputs)
	if (locale === "pl") return pl_about_content_growth_bullet_0(inputs)
	if (locale === "ru") return ru_about_content_growth_bullet_0(inputs)
	if (locale === "tr") return tr_about_content_growth_bullet_0(inputs)
	if (locale === "hi") return hi_about_content_growth_bullet_0(inputs)
	if (locale === "id") return id_about_content_growth_bullet_0(inputs)
	if (locale === "ms") return ms_about_content_growth_bullet_0(inputs)
	if (locale === "cs") return cs_about_content_growth_bullet_0(inputs)
	if (locale === "el") return el_about_content_growth_bullet_0(inputs)
	if (locale === "he") return he_about_content_growth_bullet_0(inputs)
	if (locale === "af") return af_about_content_growth_bullet_0(inputs)
	if (locale === "hu") return hu_about_content_growth_bullet_0(inputs)
	return en_about_content_growth_bullet_0(inputs)
});